import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { ReturnReasonMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  returnReasonFromModel,
  validateReturnReasonCondition,
  type ReturnReasonState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_REASON_STEP_TYPE_NAME =
  CONDITION_NAMES[Condition.RETURN_REASON];

export const RETURN_REASON = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnReasonState>>,
): ConditionType<ReturnReasonState, Condition.ReturnReason> => ({
  name: RETURN_REASON_STEP_TYPE_NAME,
  description(state) {
    if (state.reasons.length === 0) {
      return t(
        "Return reasons: none selected. Doesn't apply to AI return reasons.",
      );
    }
    if (state.reasons.length === 1) {
      return t(
        "Return reason: {{reason}}. Doesn't apply to AI return reasons.",
        { reason: state.reasons[0] },
      );
    }
    return t(
      "Return reasons: {{count}} selected. Doesn't apply to AI return reasons.",
      { count: state.reasons.length },
    );
  },
  Details(props: ConditionTypeDetailsProps<ReturnReasonState>) {
    return React.createElement(Details, props);
  },
  empty: { reasons: [], matchType: ReturnReasonMatchType.ANY },
  fromModel(model) {
    return returnReasonFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.RETURN_REASON,
      reasons: state.reasons,
      matchType: state.matchType,
    };
  },
  valid(state) {
    return validateReturnReasonCondition(state).valid;
  },
});
